import React from 'react';
import { getClassNameFactory } from '@dcl/ui';

export const BoldedText = (textString: string, shouldBeBold: string = '') => {
  const getClassName = getClassNameFactory('EmptySearch');
  let emptySearchMsg = textString.replace(/search term/gi, shouldBeBold);
  const textArray = emptySearchMsg.split(shouldBeBold);
  return (
    <p>
      {textArray.map((item, index) => (
        <>
          {item}
          {index !== textArray.length - 1 && (
            <span
              className={getClassName({ descendantName: 'noResultMsg-span' })}
            >
              {shouldBeBold}
            </span>
          )}
        </>
      ))}
    </p>
  );
};
